import React from 'react';
import { Box, AspectRatio, Heading } from '@hover/blueprint';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { IProsRestorationBlogArticle } from '../../../interfaces/IRestorationBlogArticle';

interface Props {
  blog: IProsRestorationBlogArticle;
}

const RestorationBlogCard: React.FC<Props> = ({ blog, ...restProps }) => (
  <Box
    flexDir="column"
    alignItems="flex-start"
    borderRadius="8px"
    overflow="hidden"
    boxShadow="distance300"
    maxW="2xl"
    w="100%"
    mx="auto"
    cursor="pointer"
    as={Link}
    to={`/blog/${blog.slug}/`}
    {...restProps}
  >
    <AspectRatio ratio={379 / 226} w="100%" mb="36px">
      <GatsbyImage image={blog.heroImage.gatsbyImageData} alt={blog.title} />
    </AspectRatio>
    <Box w="100%" px={{ base: 500, tablet: 700 }} pb={800}>
      <Heading
        as="p"
        noOfLines={3}
        textOverflow="ellipsis"
        size={400}
        marginBottom={0}
        isLight
      >
        {blog.title}
      </Heading>
    </Box>
  </Box>
);

export default RestorationBlogCard;
